import { Link, useLocation } from 'react-router-dom';
import { Phone, FileText } from 'lucide-react';

const DEFAULT_PHONE = { display: '04 70 42 72 63', tel: '+33470427263' };

// Contextualise le numéro selon la landing consultée.
const CONTEXTUAL_PHONES = {
  '/ambulance-beaulon-garnat':      { display: '04 70 42 72 63', tel: '+33470427263' },
  '/celine-ambulance-diou':         { display: '04 70 42 90 08', tel: '+33470429008' },
  '/ambulance-tronget-le-montet':   { display: '04 70 47 10 30', tel: '+33470471030' },
};

export default function MobileCTABar() {
  const { pathname } = useLocation();
  // Ambulance 03 landing has its own sticky CTA — hide the global one there.
  if (pathname.startsWith('/ambulance-03-avermes')) return null;
  const phone = CONTEXTUAL_PHONES[pathname] || DEFAULT_PHONE;
  return (
    <div className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur border-t border-border shadow-[0_-6px_24px_rgba(15,23,32,0.10)] px-3 py-2 flex gap-2 pb-[calc(env(safe-area-inset-bottom)+0.5rem)]">
      <a
        href={`tel:${phone.tel}`}
        className="flex-1 inline-flex items-center justify-center gap-2 rounded-lg bg-brand-500 px-3 py-3 text-white font-medium shadow-btn text-sm"
        data-testid="mobile-cta-call"
        aria-label={`Appeler ${phone.display}`}
      >
        <Phone className="h-4 w-4" /> Appeler · {phone.display}
      </a>
      <Link
        to="/devis"
        className="flex-1 inline-flex items-center justify-center gap-2 rounded-lg border bg-white px-3 py-3 font-medium text-anthracite-900 text-sm"
        data-testid="mobile-cta-quote"
      >
        <FileText className="h-4 w-4" /> Devis
      </Link>
    </div>
  );
}
